import { useContext } from "react";
import { useValidators } from "@/shared/utils/validate";
import { ErrorDialogContext, /**errorHandledAsync,*/ errorHandledSync, } from "@/shared/context/error-context";
import { UpdateUserPassService } from "@/features/user/services/update-pass-service";
import { useUpdatePassStates } from "@/features/user/hooks/use-update-pass-states";
// import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { utilities } from "@/shared/utils/utility";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";

interface Props {
  onTapCompleteModal: () => void;
}

export const useUpdatePass = ({ onTapCompleteModal }: Props) => {
  const updateUserPassService = new UpdateUserPassService();
  const {
    oldPassword,
    setOldPassword,
    newPassword,
    setNewPassword,
    confirmNewPassword,
    setConfirmNewPassword,
    passwordError, // パスワードのエラーメッセージ
    setPasswordError,
    isActiveUpdateButton,
    setIsActiveUpdateButton,
  } = useUpdatePassStates();

  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  // ローディング用コンテキスト
  const loadingCtx = useContext(LoadingModalContext);

  // バリデーション関数の呼び出し
  const { validatesForm } = utilities();
  const { passwordValidator } = useValidators();

  // Stateが更新されたときのコールバック ==========================
  // パスワード入力情報が更新された場合のコールバック関数定義
  const changeUpdateButtonState = () => {
    setIsActiveUpdateButton(
      oldPassword !== ""
      && newPassword !== ""
      && confirmNewPassword !== ""
    );
  };

  // パスワードの変更
  const onChangeOldPassword = (password: string) => {
    setOldPassword(password);
  };

  const onChangeNewPassword = (password: string) => {
    setNewPassword(password);
  };

  const onChangeConfirmNewPassword = (password: string) => {
    setConfirmNewPassword(password);
  };

  // ボタン押下イベント ======================================
  // 「更新」押下時のコールバック
  const onClickUpdate = async (
    oldPassword: string,
    newPassword: string,
    confirmNewPassword: string,
  ) => {
    loadingCtx.setIsLoading(true);

    try {
      if (
        oldPassword.length < 8
        || newPassword.length < 8
        || confirmNewPassword.length < 8
      ) {
        setPasswordError("パスワードが短いです。8文字以上で入力してください。");
        return;
      }
      if (
        oldPassword.length > 15
        || newPassword.length > 15
        || confirmNewPassword.length > 15
      ) {
        setPasswordError("パスワードが長いです。15文字以下で入力してください。");
        return;
      }
      if (newPassword !== confirmNewPassword) {
        setPasswordError("新しいパスワードと確認用パスワードが一致しません。");
        return;
      }
      let hasValidationError = validatesForm([passwordValidator], oldPassword, setPasswordError);
      hasValidationError = validatesForm([passwordValidator], newPassword, setPasswordError);
      hasValidationError = validatesForm([passwordValidator], confirmNewPassword, setPasswordError);

      if (!hasValidationError) {
        return;
      }

      await updateUserPassService.putUpdateUserPass({
        old_owner_pw: oldPassword,
        new_owner_pw: newPassword,
      });
      onTapCompleteModal();
    } catch (error) {
      console.log(error);
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    oldPassword,
    newPassword,
    confirmNewPassword,
    passwordError, // パスワードのエラーメッセージ
    isActiveUpdateButton,
    onChangeOldPassword: errorHandledSync(onChangeOldPassword, setError),
    onChangeNewPassword: errorHandledSync(onChangeNewPassword, setError),
    onChangeConfirmNewPassword: errorHandledSync(onChangeConfirmNewPassword, setError),
    onClickUpdate: errorHandledSync(onClickUpdate, setError),
    changeUpdateButtonState: errorHandledSync(changeUpdateButtonState, setError),
  };
};
